import {useDispatch, useSelector} from 'react-redux'
import CustomSelect from '../../core/customSelect'
import text from './text.json'
import Tooltip from '../../core/tooltip'
import {HelpIcon} from '../../../icons'
import {useEffect, useState} from 'react'
import Customer from '../../../utils/customer'
import {getActiveMembers} from '../../../stores/members'

const CustomerSwitcher = ({value, onChange, isDisabled, teamId}) => {
    const dispatch = useDispatch()
    const members = useSelector(state => state.members.members)
    const [membersOptions, setMembersOptions] = useState([])

    const formatData = (item) => {
        return {
            value: item?.customer_id,
            disabled: isDisabled && Customer.getCurrentCustomerId() !== item.customer_id,
            label: `${item?.name} ${item?.surname}`
        }
    }

    useEffect(() => {
        if (teamId) {
            dispatch(getActiveMembers(teamId))
        }
    }, [teamId])

    useEffect(() => {
        const modifiedData = members?.length > 0 ? members?.map(item => formatData(item)) : []
        setMembersOptions(modifiedData)
        onChange(modifiedData?.length > 0 ? modifiedData?.find(item => item?.value === Customer.getCurrentCustomerId()) || modifiedData?.[0] : null)
    }, [members])

    return (
        <div className="data-switcher-container mt-8">
            <CustomSelect
                placeholder={text.member}
                containerClassName="w-auto"
                options={membersOptions}
                name="customer_id"
                value={value}
                onChange={(name, data) => onChange(data)}/>
            <Tooltip placement="right" interactive trigger="click"
                content={text.customer_info_text}>
                <HelpIcon/>
            </Tooltip>
        </div>
    )
}

export default CustomerSwitcher
